import { render } from "./AppNoResults.vue?vue&type=template&id=e4273cda&scoped=true"
import script from "./AppNoResults.vue?vue&type=script&lang=js"
export * from "./AppNoResults.vue?vue&type=script&lang=js"

import "./AppNoResults.vue?vue&type=style&index=0&id=e4273cda&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4273cda"]])

export default __exports__